/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WarehouseConnectionConfigsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Process dagster for a warehouse connection config
   * @param warehouseConnectionConfigUuid warehouse connection config uuid
   * @returns void
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesWarehouseConnectionConfigDagster(
    warehouseConnectionConfigUuid: string,
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/warehouseConnectionConfig/{identifier}/dagster',
      path: {
        'warehouseConnectionConfigUuid': warehouseConnectionConfigUuid,
      },
      errors: {
        400: `default error response`,
        404: `default error response`,
        500: `default error response`,
      },
    });
  }

}
